import { Location2DSchema } from './location';
import { Schema } from 'effect';

export const PickupPointIdSchema = Schema.String;
export type PickupPointId = Schema.Schema.Type<typeof PickupPointIdSchema>;

export const PickupPointSchema = Schema.Struct({
  id: PickupPointIdSchema,
  name: Schema.String,
  location: Location2DSchema
});
export type PickupPoint = Schema.Schema.Type<typeof PickupPointSchema>;
